import backIcon from '../../../src/images/back-icon.svg';
import {useStyles} from '../../pages/POSEntry/OpeningCreateDialog/styles';
import {Dialog, LinearProgress} from "@mui/material";
import {useState, useEffect, useCallback} from 'react';
import {useListDocTypes} from "../../shared/hooks/useListDocTypesData";
import {debounce} from "lodash";
import CustomerCreationWizard from "../Customer/CustomerCreationWizard";

const ChooseCustomerDialog = ({dialogOpen, onConfirm, onCancel, preSelectedCustomer}) => {
    const classes = useStyles();

    const handleOnClose = () => {
        setSearchText('');
        setSelectedCustomer(null);
        if (onCancel)
            onCancel();
    }


    const [searchText, setSearchText] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [createCustomerDialogOpen, setCreateCustomerDialogOpen] = useState(false);

    const fields = ['name']
    const filters= {
        name: ['like', searchText],
    };

    const { isLoading:isLoading, isFetching:isFetching, data:customers, isError, error,
        refetch: refreshSearch} = useListDocTypes("searchCustomers", 'Customer', '', filters, fields)


    const debouncedSearch = useCallback(
        debounce(async (input) => {
            refreshSearch();
        }, 400),
        []
    );

    const handleChange = (event) => {
        const newValue = event.target.value;
        if (newValue && newValue.length > 0) {
            setSearchText("%" + newValue + "%")
        } else {
            setSearchText("");
        }
        debouncedSearch(newValue);
    };


    useEffect(() => {
        if (preSelectedCustomer && preSelectedCustomer.length > 0) {
            setTimeout(() => {
                setSearchText(preSelectedCustomer);
            }, 1000); // Delay of 1000 milliseconds (2 seconds)
        }
    }, [preSelectedCustomer]);

    const setCustomer = (customer) => {
        setSelectedCustomer(customer.name);

        // Handle the on confirm...
        if (customer && customer.name) {
            if (onConfirm) {
                onConfirm(customer.name);
            }
        }
    };

    const onCloseCreateCustomer = () => {
        setCreateCustomerDialogOpen(false);
    };

    const showCreateCustomerDialog = () => {
        setCreateCustomerDialogOpen(true);
    }

    const onConfirmCustomerCreated = (data) => {
        const {name} = data.data;
        if (name) {
            if (onConfirm) {
                onConfirm(name);
            }
        }

        setCreateCustomerDialogOpen(false);
    }

    return (
        <Dialog open={dialogOpen} onClose={handleOnClose}>
            <div className={classes.AddExtraWidget}>
                <div>
                    <button className="BackBtn" onClick={() => {
                        handleOnClose()
                    }}>
                        <img src={backIcon}/>

                    </button>
                </div>
                    <div className={classes.AddPaymentWidget}>
                        <div className={classes.Container}>
                            <div className={classes.Input_text}>
                                <div className='Input_text__Title'>Type name, and choose</div>
                                <div className='Input_text__Content'>
                                    <input type="text"
                                           placeholder='Type here'
                                           onChange={handleChange}
                                           className={classes.Input_text__Input}/>
                                </div>
                            </div>
                            <div className={classes.Customers}>
                                <div className='Customers__Title'>
                                    {isFetching || isLoading ? (
                                        <LinearProgress />
                                    ) : (
                                        <p>{customers?.length} results found</p>
                                    )}
                                </div>
                                <div className='Customers__List' style={{ maxHeight: '110px',height: 'auto', overflowY: 'auto' }}>
                                    {customers && customers.length > 0 ? (
                                        customers.map((customer) => (
                                            <div key={customer.name} onClick={() =>
                                                 setCustomer(customer)}
                                                 style={{
                                                     backgroundColor: selectedCustomer === customer?.name ? '#fff' : 'transparent', // Change the background color
                                                     cursor: 'pointer', // Add pointer cursor
                                                 }}
                                                >{customer.name}</div>
                                        ))
                                    ) : (
                                        <p></p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.Actions}>
                        <div>
                            <button className={classes.BtnSave} onClick={() => onConfirm(selectedCustomer)}>Search</button>
                        </div>
                        <div>&nbsp;&nbsp;&nbsp;</div>
                        <div>
                            <button className={classes.BtnSave} onClick={() => showCreateCustomerDialog()}>Create</button>
                        </div>
                    </div>
            </div>

            <div className={classes.Actions}>
                <Dialog open={createCustomerDialogOpen}>
                    <CustomerCreationWizard onClose={onCloseCreateCustomer} onConfirm={onConfirmCustomerCreated}/>
                </Dialog>
            </div>
        </Dialog>
    );
}

export default ChooseCustomerDialog;
